import {Stack,} from '@mantine/core';
import {PaymentIntent,} from '../types';
import {PlatformPropertyCard} from '@flexinet/ui-components';
import {StripeAmount} from "../../../components/StripeAmount.tsx";
import {CustomerLink} from '../../customers/links/CustomerLink.tsx';
import {StatusBadge} from './StatusBadge';


export const Profile = ({record}: { record: PaymentIntent }) => {

    const properties = [
        {
            label: 'Amount',
            value: <StripeAmount amount={record.amount} currency={record.currency}/>,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Customer',
            // ⚠️ `customerId` is `String` (NULLABLE) on the schema — a payment
            // intent can exist before a customer is attached. Rendering the
            // link unconditionally built one pointing at `/customers/undefined`
            // (§13: nullable fields render a placeholder, never blank).
            value: record.customerId
                ? (
                    <CustomerLink record={{
                        id: record.customerId,
                        name: record.customerId,
                    }}/>
                )
                : '—',
            span: 12,
        }, {
            label: 'Status',
            value: <StatusBadge status={record.status}/>,
            span: 12,
        }, {
            label: 'Client Secret',
            // ⚠️ MONEY PATH. Shown as-is, exactly as before — this profile is
            // already behind GetPaymentIntent RBAC and the checkout tab on this
            // same page needs the operator to be able to read it. Not widened,
            // not narrowed; only the null case is handled.
            value: record.clientSecret ?? '—',
            span: 12,
        }, {
            label: 'Payment Method',
            value: record.paymentMethod ?? '—',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'ID',
            value: record.id,
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
